/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} About_Missiondesc1Inputs */

const zh_about_missiondesc1 = /** @type {(inputs: About_Missiondesc1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`我们相信，优秀的教育不应受限于资源和技术门槛。借助 AI 的力量，StudyOS 将复杂的内容创作变得简单直观，让老师专注于教学本身，让学生在互动中真正理解和掌握知识。`)
};

const en_about_missiondesc1 = /** @type {(inputs: About_Missiondesc1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`We believe great education should not be limited by resources or technical barriers. Powered by AI, StudyOS transforms complex content creation into something simple and intuitive, letting teachers focus on teaching and students truly understand through interaction.`)
};

const es_about_missiondesc1 = /** @type {(inputs: About_Missiondesc1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Creemos que la gran educación no debería estar limitada por recursos o barreras técnicas. Impulsado por IA, StudyOS transforma la creación de contenido complejo en algo simple e intuitivo, permitiendo a los profesores enfocarse en enseñar y a los estudiantes comprender realmente a través de la interacción.`)
};

/**
* | output |
* | --- |
* | "We believe great education should not be limited by resources or technical barriers. Powered by AI, StudyOS transforms complex content creation into somethin..." |
*
* @param {About_Missiondesc1Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const about_missiondesc1 = /** @type {((inputs?: About_Missiondesc1Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<About_Missiondesc1Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_about_missiondesc1(inputs)
	if (locale === "en") return en_about_missiondesc1(inputs)
	return es_about_missiondesc1(inputs)
});
export { about_missiondesc1 as "about_missionDesc" }